/**
 * Task template meta data is free-form JSON, so a value the editor wrote as a string can come
 * back as a boolean (or the other way around). Compare and read values tolerantly.
 */

const BOOLEAN_INPUT_TYPES = ['boolean', 'bool', 'checkbox', 'switch', 'toggle'];

export const isBooleanFieldType = (type: string) => BOOLEAN_INPUT_TYPES.includes(type);

export const toBooleanFieldValue = (value: unknown) => value === true || value === 'true';

/** Options can carry non-string values, so match on the string form instead of on identity. */
export const findFieldOption = <T extends { value: unknown }>(options: T[], value: unknown): T | null => {

  if (value === undefined || value === null || value === '') return null;
  return options.find((option) => String(option.value) === String(value)) ?? null;

};
